import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Typography } from '@mui/material'
import moment from 'moment'
import { makeStyles } from 'tss-react/mui'

import { CalendarEventType } from './Calendar'
import CalendarEvent from './CalendarEvent'

const useStyles = makeStyles()((theme) => ({
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
}))

interface ShowMorePanelProps {
  events: CalendarEventType[]
  date: Date
  onClose?: () => void
}

const ShowMorePanel: React.FC<React.PropsWithChildren<ShowMorePanelProps>> = ({
  events,
  date,
  onClose,
}) => {
  const { classes } = useStyles()
  return (
    <div style={{ padding: '8px', maxWidth: '300px' }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        minWidth="200px"
        position={'relative'}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="caption" color="textSecondary">
            {moment(date).format('MMM')}
          </Typography>
          <Typography variant="h6">{moment(date).date()}</Typography>
        </Box>
        <IconButton
          size="small"
          onClick={onClose}
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      {events.map((event) => (
        <Box marginBottom={1}>
          <CalendarEvent event={event} onClose={onClose} />
        </Box>
      ))}
    </div>
  )
}

export default ShowMorePanel
